import Component from '../inherited/Component'

export default class TypewriterEffect extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    this._typewriterEffect()
  }

  _typewriterEffect () {
    const text = this._options.text
    const element = this._elem
    let speed = 100
    let index = 0
    
    function typeWriter() {
      speed = Math.floor(Math.random() * 3) + 50
      if (index < text.length) {
        element.textContent += text.charAt(index)
        index++;
        setTimeout(typeWriter, speed)
      }
    }

    typeWriter()
  }
}